import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-list-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './list-skeleton.component.html',
  styleUrls: ['./list-skeleton.component.scss']
})
export class ListSkeletonComponent {
  @Input() type: 'list' | 'media-tile' | 'composition-detail' | 'screen-detail' = 'list';
  @Input() pillsCount = 3;
  @Input() rowsCount = 5;
  @Input() colsCount = 5;
  @Input() showSearch = true;
  @Input() showButton = true;

  getFakeArray(count: number): number[] {
    return Array(count).fill(0);
  }
}
